import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import { Page, Header } from 'components'
import { Results } from './components'
import constants from 'utils/constants'
import { useAuth } from 'hooks/useAuth'
import useRouter from 'utils/useRouter'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
}))

const listaDadosGerenciaveis = [
  {
    modelo: 'CALIBRE_NOMINAL_ARMA_DE_FOGO',
    nome: 'Calibre Nominal de Arma de Fogo',
  },
  {
    modelo: 'ESTADO_CONSERVACAO_ARMA_DE_FOGO',
    nome: 'Estado de Conservação de Arma de Fogo',
  },
  {
    modelo: 'LOCAL_FABRICACAO_ARMA_DE_FOGO',
    nome: 'Local de Fabricação de Arma de Fogo',
  },
  {
    modelo: 'LOCAL_GRAVACAO_NUMERACAO_DE_MONTAGEM_ARMA_DE_FOGO',
    nome: 'Local de Gravação da Numeração de Montagem de Arma de Fogo',
  },
  {
    modelo: 'LOCAL_GRAVACAO_NUMERACAO_DE_SERIE_ARMA_DE_FOGO',
    nome: 'Local de Gravação da Numeração de Série de Arma de Fogo',
  },
  { modelo: 'MARCA_ARMA_DE_FOGO', nome: 'Marca de Arma de Fogo' },
  { modelo: 'MODELO_ARMA_DE_FOGO', nome: 'Modelo de Arma de Fogo' },
  {
    modelo: 'SISTEMA_CARREGAMENTO_ARMA_DE_FOGO',
    nome: 'Sistema de Carregamento de Arma de Fogo',
  },
  {
    modelo: 'SISTEMA_FUNCIONAMENTO_ARMA_DE_FOGO',
    nome: 'Sistema de Funcionamento de Arma de Fogo',
  },
  {
    modelo: 'SISTEMA_PERCUSSAO_ARMA_DE_FOGO',
    nome: 'Sistema de Percussão de Arma de Fogo',
  },
  {
    modelo: 'TIPO_ACABAMENTO_ARMA_DE_FOGO',
    nome: 'Tipo de Acabamento de Arma de Fogo',
  },
  {
    modelo: 'TIPO_ALCA_DE_MIRA_ARMA_DE_FOGO',
    nome: 'Tipo de Alça de Mira de Arma de Fogo',
  },
  {
    modelo: 'TIPO_ALMA_DO_CANO_ARMA_DE_FOGO',
    nome: 'Tipo de Alma do Cano de Arma de Fogo',
  },
  { modelo: 'TIPO_ARMA_DE_FOGO', nome: 'Tipo de Arma de Fogo' },
  {
    modelo: 'TIPO_CARREGADOR_ARMA_DE_FOGO',
    nome: 'Tipo de Carregador de Arma de Fogo',
  },
  {
    modelo: 'TIPO_CORONHA_ARMA_DE_FOGO',
    nome: 'Tipo de Coronha de Arma de Fogo',
  },
  {
    modelo: 'TIPO_EMPUNHADURA_ARMA_DE_FOGO',
    nome: 'Tipo de Empunhadura de Arma de Fogo',
  },
  {
    modelo: 'TIPO_GRAVACAO_ARMA_DE_FOGO',
    nome: 'Tipo de Gravação de Arma de Fogo',
  },
  {
    modelo: 'TIPO_GUARDA_MAO_ARMA_DE_FOGO',
    nome: 'Tipo de Guarda-mão de Arma de Fogo',
  },
  {
    modelo: 'TIPO_MASSA_DE_MIRA_ARMA_DE_FOGO',
    nome: 'Tipo de Massa de Mira de Arma de Fogo',
  },
  {
    modelo: 'TIPO_MECANISMO_DISPARO_ARMA_DE_FOGO',
    nome: 'Tipo de Mecanismo de Disparo de Arma de Fogo',
  },
  {
    modelo: 'NUMERACAO_DE_MONTAGEM_ARMA_DE_FOGO',
    nome: 'Numeração de Montagem de Arma de Fogo',
  },
  {
    modelo: 'NUMERACAO_DE_SERIE_ARMA_DE_FOGO',
    nome: 'Numeração de Série de Arma de Fogo',
  },
  {
    modelo: 'TIPO_TAMBOR_ARMA_DE_FOGO',
    nome: 'Tipo de Tambor de Arma de Fogo',
  },
  {
    modelo: 'TIPO_TELHA_ARMA_DE_FOGO',
    nome: 'Tipo de Telha de Arma de Fogo',
  },
  {
    modelo: 'CALIBRE_NOMINAL_CARTUCHO',
    nome: 'Calibre Nominal de Cartucho/Estojo',
  },
  {
    modelo: 'CAPSULA_ESPOLETAMENTO_CARTUCHO',
    nome: 'Cápsula de espoletamento de Cartucho/Estojo',
  },
  {
    modelo: 'FABRICANTE_CARTUCHO',
    nome: 'Fabricante de Cartucho/Estojo',
  },
  {
    modelo: 'TIPO_ESTOJO_CARTUCHO',
    nome: 'Tipo de Estojo de Cartucho',
  },
  {
    modelo: 'TIPO_PROJETIL_CARTUCHO',
    nome: 'Tipo de Projétil de Cartucho',
  },
  {
    modelo: 'CALIBRE_COMPATIVEL_ELEMENTO_MUNICAO',
    nome: 'Calibre Compatível de Elemento de Munição',
  },
  {
    modelo: 'ESPECIE_ELEMENTO_MUNICAO',
    nome: 'Espécie de Elemento de Munição',
  },
  {
    modelo: 'RESSALTOS_E_CAVADOS_ELEMENTO_MUNICAO',
    nome: 'Ressaltos e Cavados de Elemento de Munição',
  },
  {
    modelo: 'TIPO_ELEMENTO_MUNICAO',
    nome: 'Tipo de Elemento de Munição',
  },
]

export const DadosGerenciaveis = (props) => {
  const { route } = props
  const classes = useStyles()
  const router = useRouter()
  const { permissoesUsuario, verificarPermissao } = useAuth()

  useEffect(() => {

    if (permissoesUsuario?.length) {
      if(!verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA])) {
        router.history.push(`/`)
      }
    }
  }, [permissoesUsuario])

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header title={`${route.secao}`} overline={route.secao} />
      <Results className={classes.results} dados={listaDadosGerenciaveis} />
    </Page>
  )
}
